import _slicedToArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.at.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.at-alternative.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable';
import birthday_nav_config from './birthday_nav_config.vue';
import goods_nav_config from './goods_nav_config.vue';
import { guid } from '@/utils';
export default {
  name: 'super_nav_config',
  components: {
    draggable: draggable,
    birthday_nav_config: birthday_nav_config,
    goods_nav_config: goods_nav_config
  },
  props: {
    disabled: Boolean,
    styleId: [String, Number],
    source: String,
    // template:模板库
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: Array,
    childrenMenuList: Array,
    customerModuleList: Array,
    eBookCategoryList: Array,
    aBookCategoryList: Array,
    customerPackageList: Array,
    systemMenus: Object,
    tabListFlat: Array,
    info: Object,
    uploadInfo: Object
  },
  data: function data() {
    return {
      defaultValue: {
        name: '',
        name_color: '#333333',
        sub_name: '',
        sub_name_color: '#666666',
        id: [],
        menus_type: '',
        key: '',
        config: {},
        valid: false //记录弹窗内引用组件表单校验是否成功
      },
      showDrawer: false,
      updateIndex: 0,
      configData: {}
    };
  },
  methods: {
    saveConfig: function saveConfig() {
      var _this = this;
      this.$refs.commonConfig.$refs.form.validate(function (valid, obj) {
        _this.value.config.value[_this.updateIndex].valid = valid;
        if (valid) {
          _this.value.config.value[_this.updateIndex].config = _objectSpread({}, _this.configData.config);
          _this.showDrawer = false;
        } else {
          var _Object$values, _Object$values$, _Object$values$$;
          var errorMsg = ((_Object$values = Object.values(obj)) === null || _Object$values === void 0 ? void 0 : (_Object$values$ = _Object$values[0]) === null || _Object$values$ === void 0 ? void 0 : (_Object$values$$ = _Object$values$[0]) === null || _Object$values$$ === void 0 ? void 0 : _Object$values$$.message) || '请完善表单信息';
          _this.$message.error(errorMsg);
        }
      });
      return;
    },
    openConfig: function openConfig(index) {
      this.updateIndex = index;
      var data = JSON.parse(JSON.stringify(this.value.config.value[index]));
      this.configData = data;
      var _this$configData$id = this.configData.id,
        id = _this$configData$id === void 0 ? [] : _this$configData$id;
      var _id = _slicedToArray(id, 1),
        _id$ = _id[0],
        firstMenuId = _id$ === void 0 ? '' : _id$;
      var lastMenuId = id.at(-1);
      var _ref = this.menuListFilter.find(function (i) {
          return i.id === firstMenuId;
        }) || {},
        _ref$type = _ref.type,
        type = _ref$type === void 0 ? '' : _ref$type;
      this.value.config.value[index].menus_type = type;
      this.configData.menus_type = type;
      switch (type) {
        case 'entity':
        case 'new_entity':
          this.value.config.value[index].key = 'goods_nav';
          this.configData.key = 'goods_nav';
          this.configData.config.category_id = lastMenuId;
          this.configData.config.is_show_title = 0; // 不展示顶部tab
          break;
        case 'cake':
        case 'new_cake':
        case 'cake_store':
          this.value.config.value[index].key = 'birthday_nav';
          this.configData.key = 'birthday_nav';
          this.configData.config.category_id = lastMenuId;
          break;
      }
      this.showDrawer = true;
    },
    changeMenu: function changeMenu(menu_ids, item) {
      item.valid = false;
    },
    addBox: function addBox() {
      this.value.config.value.push(_objectSpread(_objectSpread({}, this.defaultValue), {}, {
        uid: guid()
      }));
    },
    onDelete: function onDelete(index) {
      var _this2 = this;
      this.$confirm("\u786E\u5B9A\u8981\u5220\u9664\u5206\u7C7B".concat(index + 1, "\u5417"), '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        _this2.value.config.value.splice(index, 1);
      }).catch(function () {});
    }
  },
  created: function created() {
    this.$set(this.value, 'config', _objectSpread({
      is_open_sub_name: '1',
      //是否开启副标题
      selected_color: '#c20c0c',
      //主题色 - 应用于选中tab标题颜色 & 副标题背景色 & 副标题文字颜色固定为白色
      margin_top: 15,
      z_index: 2,
      value: [_objectSpread(_objectSpread({}, this.defaultValue), {}, {
        uid: guid()
      })]
    }, this.value.config));
  },
  computed: {
    menuListFilter: function menuListFilter() {
      return this.menuList.filter(function (i) {
        return ['cake',
        //蛋糕到家
        'new_cake',
        //蛋糕到家
        'cake_store',
        //蛋糕到店

        'entity',
        //实体
        'new_entity' //实体

        // 'code', //券码
        ].includes(i.type);
      });
    }
  }
};